/** @deprecated Quarantined legacy (WEB-8988) — moved out of the Angular tree so the ReactTemplates ROW.visitorRow global survives Phase 6. Do not import in new code. */
// Creates window.ReactTemplates and its namespaces. The shim already evaluates the aggregator
// before this file, but a direct importer of the exports below (WEB-8902) does not — without this
// the module-scope ROW assignments run against an undefined global.
import {
	emptyTD,
	toolsDateCalendar,
	accountHref as AccountHref,
	leadStatus as LeadStatus,
	checkboxTD as CheckboxTD,
	genericTD,
	contactsText
} from './index';
import AppService from 'App/legacy/AppService';
import LeadSource from 'Components/Columns/LeadSource';
import { currencyRange } from 'Components/Filters/Currencies';
import CountryCodes from 'App/services/CountryCodes';
import { Feature, isAvailable } from 'App/services/FeatureHelperStandalone';
import T from 'Components/Helpers/translate';
import JourneyStepDisplay from 'Components/JourneyStepDisplay';
import DisqualifyDropDown from 'Components/JourneyStepDisplay/DisqualifyDropDown';
import { Icon, Button, Tooltip } from '@upsales/components';
import BuyFromDataSourceInline from 'Components/Modals/BuyFromDataSourceInline';
import store from 'Store';
import { Provider } from 'react-redux';
import GroupTreeColumn from 'Components/Prospecting/ProspectingGroupTree';
import JourneyStepIcon from 'Components/JourneyIcon/JourneyStepIcon';
import Client from 'App/resources/Client';
import logError from 'App/babel/helpers/logError';
import openModal from 'App/services/Modal/Modal';
import { openEditAppointment } from 'Components/Modals/Appointment/EditAppointment';
import { openDrawer } from 'Services/Drawer';
import { processedByColumn as ProcessedByColumn } from 'App/babel/components/LegacyReactTemplates/processedBy';

ReactTemplates.ROW.visitorRow = window.ReactCreateClass({
	displayName: 'visitorRow',
	UNSAFE_componentWillUpdate: function () {},
	click: function (e) {
		this.props.tools.opts.clickedEntry(this.props.item, e);
	},
	findBisnodeInt: function (array) {
		return _.find(array, function (item) {
			return item.alias === 'BISNODE_INTERNATIONAL';
		});
	},
	bisnodeInternationalActive: function () {
		var object = { bool: false };
		var availableIntegrations = AppService.getMetadata().integrations;

		if (
			availableIntegrations.inits &&
			availableIntegrations.inits.dataSource &&
			availableIntegrations.inits.dataSource.length
		) {
			var obj = this.findBisnodeInt(availableIntegrations.inits.dataSource);

			if (obj) {
				object.bool = true;
			}

			object.object = obj;
		}

		return object;
	},
	createAccount: function (e) {
		var self = this;
		self.setState({ loading: true });
		self.props.tools.opts
			.createAccount(self.props.item, e)
			.then(function () {
				self.setState({ loading: false });
			})
			.catch(() => self.setState({ loading: false }));
	},
	getInitialState: function () {
		return { loading: false };
	},
	openEmail: function (mailId, event) {
		event.preventDefault();
		event.stopPropagation();

		openDrawer('SentMail', { mail: { id: mailId } });
	},
	openProcessedByModal: function (e) {
		e.stopPropagation();
		e.nativeEvent.stopImmediatePropagation();

		openModal('AssignModal', { client: this.props.item.client });
	},
	openActivity: function (e) {
		e.stopPropagation();
		e.nativeEvent.stopImmediatePropagation();

		var $upModal = this.props.tools.$upModal;
		var client = this.props.item.client;

		$upModal.open('editActivity', { id: client.processedBy.id });
	},
	unassign: function (e) {
		this.props.tools.opts.unassign(this.props.item, e);
	},
	disqualifyAccount: function (e) {
		var self = this;
		this.setState({ loading: true });
		this.props.tools.opts
			.disqualify(this.props.item, e)
			.then(function () {
				self.setState({ loading: false });
			})
			.catch(() => self.setState({ loading: false }));
	},
	openAppointment: function (e) {
		e.stopPropagation();
		e.nativeEvent.stopImmediatePropagation();

		var customerId = this.props.tools.AppService.getCustomerId();
		var client = this.props.item.client;

		openEditAppointment({ customerId: customerId, id: client.processedBy.id });
	},
	getCountryNameFromCountryCode: function (code) {
		var country = CountryCodes.getCountry(code);
		return country ? T(country.lang) : code;
	},
	render: function () {
		var self = this;
		var item = this.props.item;
		var tools = this.props.tools;
		var options = tools.opts;
		var statics = this.props.statics;
		var customerId = tools.AppService.getCustomerId();
		var attrs = this.props.attrs;
		var style, icon;

		var getTime = function (visit) {
			var seconds = moment(visit.endDate).diff(moment(visit.startDate), 'seconds');
			var duration = moment().startOf('day').add('s', seconds);
			var format = '';

			if (!duration.hour() && !duration.minute() && !duration.second()) {
				return '-';
			}

			if (duration.hour() > 0) {
				format += 'H[h] ';
			}

			if (duration.minute() > 0) {
				format += 'm[m] ';
			}

			format += 's[s]';

			return duration.format(format);
		};

		var getColumn = function (column, item) {
			var address;
			var key = 'column-' + column;

			switch (column) {
				case 'country':
					return (
						<td key={key}>
							<i
								style={{ marginRight: 5 }}
								className={'flag-icon flag-icon-' + (item.country || '').toLowerCase()}
							/>
							{self.getCountryNameFromCountryCode(item.country)}
						</td>
					);
				case 'startDate':
					return (
						<td key={key} className="column-startDate">
							{toolsDateCalendar(item.startDate, 'L')} {moment(item.startDate).format('HH:mm')}
						</td>
					);
				case 'account':
				case 'client':
					var contact = null;
					var client = null;

					if (item.contact) {
						contact = (
							<span>
								{contactsText(customerId, [item.contact], tools)}
								<span> {statics.at.toLowerCase()} </span>
							</span>
						);
					}
					if (item.client && !item.client.isExternal && item.client.name) {
						client = (
							<AccountHref
								customerId={customerId}
								id={item.client.id}
								text={item.client.name}
								tools={tools}
							/>
						);
					} else if (!item.client || !item.client.name) {
						client = (
							<span className="grey">
								<i>{statics.undidentifiedVisit} </i>
								<Tooltip title={statics.undidentifiedVisitDescription} position="top">
									<i className="fa fa-info-circle" />
								</Tooltip>
							</span>
						);
					} else if (item.client.isExternal) {
						address = item.client.mailAddress;
						client = (
							<span
								onClick={function (event) {
									event.preventDefault();
									event.stopPropagation();
								}}
							>
								{item.client.name}
								{self.state.loading ? (
									<b style={{ marginLeft: '5px' }} className="fa fa-refresh fa-spin" />
								) : (
									<Provider store={store}>
										<BuyFromDataSourceInline
											onConfirm={clientId => {
												if (clientId) {
													Client.save({
														id: clientId,
														sourceType: 'visit',
														sourceId: item.id
													}).catch(err => logError(err, 'Could not save client'));
												}
											}}
											account={item.client}
											hasDataSource={self.bisnodeInternationalActive().bool}
											dataSourceId={
												self.bisnodeInternationalActive().object &&
												self.bisnodeInternationalActive().object.id
											}
										/>
									</Provider>
								)}
							</span>
						);
					}
					return (
						<td key={key}>
							{contact}
							{client}
						</td>
					);

				case 'location':
					if (!item.client) {
						return emptyTD('', key);
					}

					address = item.client.mailAddress;

					if (!address || (!address.city && !address.country)) {
						return emptyTD('', key);
					}
					var txt = '';
					style = { width: '30px', textAlign: 'center' };
					icon = <b className="icon fa fa-map-marker" style={style} />;

					if (address.city?.length) {
						txt = address.city;
					}

					if (!txt && address.state?.length) {
						txt = address.state;
					}

					if (address.country) {
						icon = (
							<b className={'icon flag-icon flag-icon-' + address.country.toLowerCase()} style={style} />
						);
					}

					return (
						<td key={key}>
							{icon}
							{txt}
						</td>
					);

				case 'sales':
					return (
						<td key={key}>
							{item.client && item.client.turnover ? (
								<span>{currencyRange(item.client.turnover * 1000, item.client.currency || '')}</span>
							) : (
								<i className="grey">{statics.noData}</i>
							)}
						</td>
					);

				case 'groupStructure':
					return (
						<td key={key}>
							<GroupTreeColumn
								prospectingId={item.client.prospectingId}
								country={item.client.country}
								existingClient={item.client}
							></GroupTreeColumn>
						</td>
					);

				case 'status':
					return (
						<td key={key}>
							{item.client ? (
								<LeadStatus
									theKey={item.id}
									tools={tools}
									activity={item.client.hasActivity}
									activityOld={item.client.hadActivity}
									appointment={item.client.hasAppointment}
									appointmentOld={item.client.hadAppointment}
									opportunity={item.client.hasOpportunity}
									opportunityOld={item.client.hadOpportunity}
									order={item.client.hasOrder}
									orderOld={item.client.hadOrder}
								/>
							) : null}
						</td>
					);

				case 'time':
					return <td key={key}>{getTime(item)}</td>;

				case 'score':
					return (
						<td key={key} className="no-overflow">
							<b>{item.score + 'p'}</b>
						</td>
					);

				case 'pages':
					return <td key={key}>{item.pages.length}</td>;

				case 'assigned':
					return (
						<ProcessedByColumn
							disabled={!item.client || item.client.isExternal || !item.client.userEditable}
							client={item.client}
							item={item}
							tools={tools}
							options={options}
							theKey={key}
						/>
					);

				case 'leadSource':
					return (
						<td key={key} className="column-leadSource">
							<LeadSource visit={item} />
						</td>
					);

				case 'utmCampaign':
				case 'utmContent':
				case 'utmMedium':
				case 'utmSource':
				case 'utmTerm': {
					const config = attrs[column];
					const value = _.get(item, config.field, '');

					return <td key={key}>{value}</td>;
				}

				case 'journeyStep':
				case 'clientJourneyStep':
					var clientJourneyStep = item.client ? item.client.journeyStep : undefined;
					return (
						<td key={key} className="account-contact-col">
							<JourneyStepIcon id={clientJourneyStep} />
						</td>
					);
				case 'contactJourneyStep':
					var contactJourneyStep = item.contact ? item.contact.journeyStep : undefined;
					return (
						<td key={key} className="account-contact-col">
							<JourneyStepIcon id={contactJourneyStep} />
						</td>
					);

				default:
					return genericTD(tools, attrs, column, item, key);
			}
		};

		var tds = this.props.columns.map(function (column) {
			return getColumn(column, item);
		});

		var chk = <CheckboxTD tools={tools} item={item} />;

		if (tools.opts.noCheck) {
			chk = null;
		}

		let dqlLeadCol;
		if (isAvailable(Feature.JOURNEY_STATUS)) {
			dqlLeadCol =
				item.client &&
				JourneyStepDisplay.statusDisqualifiable(item.client.journeyStep) &&
				!item.client.isExternal ? (
					<DisqualifyDropDown
						id={item.clientId}
						className="DisqualifyDropDown"
						onDisqualify={this.disqualifyAccount}
						loading={self.state.loading}
						buttonText={tools.$translate('default.disqualify')}
						tooltip={tools.$translate('default.disqualifyCompany')}
					/>
				) : null;
		} else {
			dqlLeadCol = (
				<Tooltip title={tools.$translate('default.setPointsToZero')}>
					<Button onClick={this.unassign} type="link">
						<Icon name="thumbs-down" />
					</Button>
				</Tooltip>
			);
		}

		return (
			<tr key={'item-' + item.id} onClick={this.props.noClickEvt ? null : this.click}>
				{chk}
				{tds}
				<td className="column-tools">{dqlLeadCol}</td>
			</tr>
		);
	}
});

// Direct-import surface for consumers outside the Angular tree (WEB-8902); FormVisits.js renders
// it. The ROW.visitorRow registration above has had no computed-key reader since WEB-13530
// deleted formDashboard.jsx, and goes with the ROW namespace.
export const VisitorRow = ReactTemplates.ROW.visitorRow;
